import { render, staticRenderFns } from "./ModalPreviewTextbookQuestion.vue?vue&type=template&id=499cc3ee&scoped=true"
import script from "./ModalPreviewTextbookQuestion.vue?vue&type=script&lang=js"
export * from "./ModalPreviewTextbookQuestion.vue?vue&type=script&lang=js"
import style0 from "./ModalPreviewTextbookQuestion.vue?vue&type=style&index=0&id=499cc3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499cc3ee",
  null
  
)

export default component.exports